import { FullRequestParams, HttpClient, RequestParams } from './api/http-client';

const TRADE_IN_URL = '/trade-in';

export type ProductFilterItem = {
  Slug: string;
  IntagId: string;
  ChoiceSlugs: string[];
};

export type ProductsRequestData = {
  CollectionId: string;
  Items: ProductFilterItem[];
  SortType: number;
  Skip: number;
  isPriceUpdatedByUser: boolean;
  IsTariff: boolean;
  remainsOnly: boolean;
  Tag: null;
};

export class ShopApi<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  fetchPopupDetails = (currentSlug: string) =>
    this.http.request({
      method: 'GET',
      path: `/popupdetails/${currentSlug}/`,
    });

  createAntiforgery = () =>
    this.http.request({
      method: 'POST',
      path: '/basket/antiforgeryrequestjson/',
    });

  sendDetailsModalSubscribeForm = (
    data: {
      article: string | undefined;
      email: string;
      fullname: string;
    },
    headers: FullRequestParams['headers'],
  ) =>
    this.http.request({
      method: 'POST',
      body: data,
      path: '/admission/',
      headers,
    });

  fetchDeviceTypes = () =>
    this.http.request({
      method: 'GET',
      path: `${TRADE_IN_URL}/getdevicetypes/`,
    });

  fetchBrands = (deviceType: string) =>
    this.http.request({
      method: 'GET',
      path: `${TRADE_IN_URL}/getbrands/`,
      query: {
        deviceType,
      },
    });

  fetchModels = (deviceType: string, brand: string) =>
    this.http.request({
      method: 'GET',
      path: `${TRADE_IN_URL}/getmodels/`,
      query: {
        deviceType,
        brand,
      },
    });

  fetchCapacity = (deviceType: string, brand: string, model: string) =>
    this.http.request({
      method: 'GET',
      path: `${TRADE_IN_URL}/getcapacity/`,
      query: {
        deviceType,
        brand,
        model,
      },
    });

  fetchMaxPrice = (deviceType: string, brand: string, model: string, capacity: string) =>
    this.http.request({
      method: 'GET',
      path: `${TRADE_IN_URL}/getmaxprice/`,
      query: {
        deviceType,
        brand,
        model,
        capacity,
      },
    });

  fetchProducts = (data: ProductsRequestData, params: RequestParams = {}) =>
    this.http.request({
      method: 'POST',
      path: '/getproductslistbyfilters/',
      body: data,
      ...params,
    });
}
